import { createContext } from 'react'

const ModalContext = createContext({
  modals: [] as any[],
  setModals: (modals: any[]): any[] => []
})

export default ModalContext